import { API, graphqlOperation } from 'aws-amplify'
import { getOrganization } from "../../graphql/queries";

const state = {
    organization: {}
};

const getters = {
    getOrganization: (state) => state.organization,
    getOrgID: (state) => state.organization.id,
    getWebsites: (state) => state.organization.websites.items,
    getWebsiteID: state => domain => state.organization.websites.items.find(x => x.domain === domain).id
};

const actions = {
    async fetchOrganization({ commit }) {
        await API.graphql(graphqlOperation(getOrganization, {id: state.organization.id}))
            .then(org => commit('setOrganization', org))
    }
};

const mutations = {
    setOrgID: (state, orgID) => (state.organization.id = orgID),
    setOrganization: (state, org) => (state.organization = org.data.getOrganization),
};

export default {
    state,
    getters,
    actions,
    mutations
}